import WordCycler from '../../cells/WordsCycler';
import ModalGreen from '../../organs/Websites/ModalGreen';
import Process from '../../organs/Websites/Process';
import Projects from '../../organs/Websites/Projects';
import Services from '../../organs/Websites/Services';
import styles from './Content.module.css';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy } from 'react-scroll';
import { useTranslation } from "react-i18next";
import WordCyclerNL from '../../cells/WordsCyclerNL';


const Content = ({cookies}: {cookies: boolean}) => {
    const { t } = useTranslation();
    const { i18n } = useTranslation();

    return (
        <div>
            <div className={styles.blur1}></div>
            <div className={styles.blur2}></div>
            <div className={styles.blur3}></div>
            <div className={styles.blur4}></div>
            <div className={styles.container}>
                
            {i18n.resolvedLanguage === "nl" ? 
                <h1 className={styles.headline}> <WordCyclerNL/> websites <span className={styles.titleEnd}>die inspireren</span></h1>
                : 
                <h1 className={styles.headline}> <WordCycler/> websites <span className={styles.titleEnd}>tailored to inspire</span></h1>
            }
                
                <p className={styles.sub}>{t("headerSub")}</p>
                <ModalGreen cookies={cookies}/>
            </div>  
            <div className={styles.container}>
                <Element name="services">
                    <Services/>
                </Element>
            </div>
            <div className={styles.container}>
                <Element name="projects">
                    <Projects/>
                </Element>
            </div>
            <div className={styles.container}>
          
                <Element name="process">
                    <Process/>
                </Element>
  
            </div>
        </div>
        
    )
}

export default Content;